// action creators
import {
    openDealFromCustomerVehicles,
    openCompareDealPage,
    closeTradeInModal,
    continueToApplyDeal
} from '@makemydeal/dr-sales-checkin-store';

// types
import type { HostActions } from '@makemydeal/dr-activities-customer-vehicles';

export const hostActions: HostActions = {
    openDeal: openDealFromCustomerVehicles,
    compareDeal: openCompareDealPage,
    closeModal: closeTradeInModal,
    continueToApplyDeal
};
